import { createFileRoute } from "@tanstack/react-router";
import AmIACandidate from "@/pages/AmIACandidate";
export const Route = createFileRoute("/am-i-a-candidate")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Am I A Candidate | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Find out if you’re a candidate for SAINT TMS. Our free screener checks age, prior treatments, and medical history for depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Am I A Candidate | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Find out if you’re a candidate for SAINT TMS. Our free screener checks age, prior treatments, and medical history for depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/am-i-a-candidate",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/am-i-a-candidate",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AmIACandidate />;
}
